import { z } from 'zod';

const readinessSchema = z.object({
  status: z.enum(['ok', 'unavailable']),
  checks: z.object({ database: z.enum(['ok', 'error']) }),
});

export type Readiness = z.infer<typeof readinessSchema>;

// Las respuestas del servidor se validan en tiempo de ejecución antes de usarlas.
export async function fetchReadiness(fetcher: typeof fetch = fetch): Promise<Readiness> {
  const response = await fetcher('/api/v1/health/ready', { credentials: 'same-origin' });
  return readinessSchema.parse(await response.json());
}
